module.exports = __webpack_public_path__ + "static/media/folder5.2afd53ee.png";